import React, { useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { PageContainer } from "../Grid";
import { H1 } from "../TextStyles";
import { LargeButton } from "../Button";
import seatComponents from "../../seatComponents";
import { getSelectionsFromSeries } from "./seriesHelper";
import education from "./images/education.webp";
import industrial from "./images/industrial.webp";
import laboratory from "./images/laboratory.webp";
import healthcare from "./images/healthcare.webp";
import office from "./images/office.webp";
import cleanRoom from "./images/cleanRoom.webp";
import staticControl from "./images/staticControl.webp";
import cleanRoomStaticControl from "./images/cleanRoomStaticControl.jpg";
import { WizardCard, WizardCardContainer } from "../WizardCard";

const [{ data: markets }] = seatComponents.filter(({ type }) => type === "market");

const images = {
  education,
  industrial,
  laboratory,
  healthcare,
  office,
  cleanRoom,
  staticControl,
  cleanRoomStaticControl,
};

const MarketComponent = ({ code, name, description, seriesSelections }) => {
  // If series is provided, go directly to builder with all selections
  // Otherwise, follow normal flow to style selection
  const destination = seriesSelections
    ? {
        pathname: "/build",
        state: {
          market: code,
          ...seriesSelections,
        },
      }
    : {
        pathname: "/style",
        state: { market: code },
      };

  return (
    <WizardCard
      key={code}
      image={images[code]}
      imgWrapHeight="195px"
      title={name}
      description={description}
      button={
        <Link to={destination}>
          <LargeButton secondary>Select Market</LargeButton>
        </Link>
      }
    />
  );
};

const Market = () => {
  const location = useLocation();
  const history = useHistory();

  // Check for series query parameter
  const qs = queryString.parse(location.search);
  const { series } = qs;

  // Validate series and get derived selections
  const seriesSelections = series ? getSelectionsFromSeries(series) : null;

  // If series is invalid, redirect to clean market page
  useEffect(() => {
    if (series && !seriesSelections) {
      history.replace("/market");
    }
  }, [series, seriesSelections, history]);

  // Don't render if redirecting
  if (series && !seriesSelections) {
    return null;
  }

  // Filter markets based on series if provided
  const filteredMarkets = series
    ? markets.filter((market) => {
        // market.series is either ALL or an array of series codes
        return market.series === "ALL" || market.series.includes(series);
      })
    : markets;

  return (
    <PageContainer>
      <Helmet>
        <title>Choose Your Market</title>
      </Helmet>
      <H1>Choose Your Market</H1>

      <Box width={1} my="2rem">
        Get fast, easy access to all the information you need on any chair in the extensive line of
        BioFit furnishings. Or, design your ideal seating option, built to your exact
        specifications.
      </Box>
      <WizardCardContainer>
        {filteredMarkets.map((market) => (
          <MarketComponent key={market.code} {...market} seriesSelections={seriesSelections} />
        ))}
      </WizardCardContainer>
    </PageContainer>
  );
};

export default Market;
